import React, { useRef } from "react"
import PropTypes from "prop-types"
import {
  masonryGrid,
  galleryTransformer,
} from "./gallery-transformer.module.scss"

import Masonry from "react-masonry-component"

const GalleryTransformer = ({ html }) => {
  const masonry = useRef()
  return (
    <div className={galleryTransformer}>
      <Masonry className={masonryGrid} ref={masonry}>
        {html}
      </Masonry>
    </div>
  )
}

//-----------------------Component---------------------------//

//-----------------------Prop-Types---------------------------//

GalleryTransformer.propTypes = {
  html: PropTypes.array,
}

//-----------------------Prop-Types---------------------------//

export default GalleryTransformer
